import { render, staticRenderFns } from "./OrdineDestinazioni.vue?vue&type=template&id=81cc7842"
import script from "./OrdineDestinazioni.vue?vue&type=script&lang=js"
export * from "./OrdineDestinazioni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports